import React, { useState } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Button from './Button';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

const ProjektSlider = ({ shortTitle, projects, seperator=false }) => {
    const slides = [1, 2, 3, 4, 5, 6, 7, 8];
    const [current, setCurrent] = useState(1);
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        // autoplay: true,
        // autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,          // ✅ enables fade effect
        cssEase: "linear",
        beforeChange: (oldIndex, newIndex) => {
            setCurrent(newIndex + 1);
        }
    };
    const total = projects.length;
    const progress = (current / total) * 100;

    const [buttons, setButtons] = useState([{
        button_text: "zum Projekt",
        button_link: "/"
    }]);

    return (
        <div className='slider_wrapper projekt_slider pt-pb-10' style={{borderBottom: seperator ? '1px solid #d2d2d2' : 'unset'}}>
        
            <Slider {...settings}>
                {projects.map((project, index) => (
                    <div key={index} className='slider_slide_item' >
                        <div className='row'>
                            <div className={`col-lg-6 text-col ${shortTitle ? 'mt-lg-0' : 'mt-lg-5' } mb-lg-0 mb-4`}>
                                <div className='content_padd_bottom'>
                                    {shortTitle && <div class="subtitle">{shortTitle}</div>}
                                    <h2 className="text-black">{project?.Page_Titel}</h2>
                                    {/* <p>{project?.Bannerbereich[0]?.Text}</p> */}
                                    {project?.Ubersichtstext && <p>{project?.Ubersichtstext}</p> }
                                    {/* {project?.Ubersichtstext && <BlocksRenderer content={project?.Ubersichtstext} />} */}
                                    <Button buttons={[{ button_text: "zum Projekt", button_link: `/${project?.Page_Template?.toLowerCase()}/${project?.slug}` }]} btnStyle="round_btn" />
                                </div>
                            </div>
                            <div className='col-lg-6 img-col'>
                                <img src={`https://backend.bgzurlinden.ch${project?.Beitrags_Miniaturbild?.url}`} className='w-100' alt='#' />
                            </div>
                        </div>
                    </div>
                ))
                }
            </Slider >
            {/* Top Section */}
            < div className="slider-count-progress" >
                <div className='slide_item_count'>
                    <span className="current"> {current < 10 ? `0${current}` : current} </span>
                    {" / "}
                    <span className="total"> {total < 10 ? `0${total}` : total} </span>
                </div>
                <div className="progress">
                    <div className="progress-bar" style={{ width: `${progress}%` }}></div>
                </div>
            </div >
        </div >
    )
}

export default ProjektSlider